import { G } from '@mobily/ts-belt';
import { CrossSellPromo } from '@stitch-fix/mode-react';
import { useViewEvent } from '@stitch-fix/event-reporter';
import { type GetFixPromotionQueryVariables, useGetFixPromotionQuery } from '../../utils/hooks/getFixPromotion';
import { themeMapping } from '../../utils/maps';
interface FixPromotionProps {
  version?: NonNullable<GetFixPromotionQueryVariables['version']>;
}

/**
 * The `FixPromotion` component requests and renders the content
 * for the CrossSellPromo component.
 */
const FixPromotion = ({
  version = 'DEFAULT'
}: FixPromotionProps) => {
  const {
    data
  } = useGetFixPromotionQuery({
    variables: {
      version
    }
  });
  const fixPromotion = data?.shopContent?.fixPromotion;
  const {
    ref,
    EventProvider,
    reportSelectEvent
  } = useViewEvent({
    content_id: 'order_a_fix',
    name: 'call_to_action_module',
    schema: 'view'
  });
  if (!G.isObject(fixPromotion)) return null;
  return <EventProvider>
      <div ref={ref}>
        <CrossSellPromo variant="fix" image={fixPromotion.image} expandedContent={fixPromotion.expandedContent} cta={fixPromotion.cta} stickerLabel={fixPromotion.stickerLabel?.label ? {
        label: fixPromotion.stickerLabel.label,
        variant: themeMapping[fixPromotion.stickerLabel.theme]
      } : undefined} onClick={() => {
        reportSelectEvent({
          action_name: 'navigate_to_call_to_action_destination',
          content_id: 'order_a_fix',
          name: 'call_to_action_module',
          schema: 'select'
        });
      }} />
      </div>
    </EventProvider>;
};
export default FixPromotion;